import request from '@/utils/request'
import URL from './urlTranslator'

export function loadAnnouncement() {
  return request({
    url: URL.sys.queryAnnouncementList,
    method: 'get'
  })
}

export function getUnread(domain, sessionId) {
  return request({
    url: domain,
    method: 'get',
    params: { sessionId }
  })
}

export function unreadNum(domain, sessionId) {
  return request({
    url: domain,
    method: 'get',
    params: { sessionId }
  })
}

export function getCarouselList(domain, params) {
  return request({
    url: domain,
    method: 'get',
    params: params
  })
}

